/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionWaterPreloadingPagedList } from '../../models/subscription-water-preloading-paged-list';

export interface SearchWaterPreloading$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;
}

export function searchWaterPreloading(http: HttpClient, rootUrl: string, params: SearchWaterPreloading$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionWaterPreloadingPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchWaterPreloading.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionWaterPreloadingPagedList>;
    })
  );
}

searchWaterPreloading.PATH = '/custom/subscriptions/{uid}/water/preloading/search';
